import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../services/order.service';
import { DataLayerService } from '../../services/datalayer.service';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html'
})
export class ThankYouComponent implements OnInit {
  orderId = '';
  order: any = null;
  loading = true;
  error = '';

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private orderService: OrderService,
    private dataLayer: DataLayerService,
    private state: AppStateService,
  ) {}

  ngOnInit() {
    // Backend deleted cart on payment success — sync frontend state
    this.state.loadCartFromApi(true);
    this.route.queryParams.subscribe(params => {
      this.orderId = params['order_id'] || '';
      if (this.orderId) {
        this.loadOrder();
      } else {
        this.loading = false;
      }
    });
  }

  loadOrder() {
    this.loading = true;
    this.orderService.getOrder(this.orderId).subscribe({
      next: (res: any) => {
        this.order = res?.data || res;
        this.loading = false;
        // E2 — purchase event
        if (this.order) {
          this.firePurchaseEvent();
        }
      },
      error: () => {
        this.error = 'Could not load order details.';
        this.loading = false;
      }
    });
  }

  private firePurchaseEvent(): void {
    const o = this.order;
    const items = (o.order_items || o.items || []).map((item: any) => {
      const cp = item.customizedProduct || item.customized_product || item;
      const cpItems = cp.customizedProductItems || cp.customized_product_items || [];
      const firstItem = cpItems[0] || {};
      let img: any = firstItem.image_detail || {};
      if (typeof img === 'string') { try { img = JSON.parse(img); } catch { img = {}; } }
      return {
        item_id:       img.image_id || cp.wallpaper_id || String(item.id),
        item_name:     img.image_caption || cp.name || 'Item',
        item_brand:    'MahattaArt',
        item_category: cp.category_name || cp.product_type || 'Wallpaper',
        item_variant:  cp.surface_name || cp.variant || '',
        price:         item.amount_payable || item.price || 0,
        quantity:      cp.quantity || item.quantity || 1
      };
    });

    const txnId    = String(o.order_id || o.id || this.orderId);
    const value    = o.grand_total || o.amount_payable || items.reduce((s: number, i: any) => s + i.price * i.quantity, 0);
    const tax      = o.tax || o.total_tax || 0;
    const shipping = o.shipping_amount || o.shipping || 0;
    const discount = o.discount || o.discount_amount || o.coupon_discount || 0;
    const coupon   = o.coupon || o.coupon_code || '';
    const paymentType = o.payment_method || o.payment_type || o.payment_gateway || '';

    this.dataLayer.push('purchase', {
      ecommerce: {
        event_id:       'purchase_evt_' + txnId,
        transaction_id: txnId,
        value, tax, shipping, discount,
        currency: 'INR',
        ...(coupon      && { coupon }),
        ...(paymentType && { payment_type: paymentType }),
        items
      }
    });
  }

  get estimatedDelivery(): string {
    const d = new Date();
    d.setDate(d.getDate() + 7);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  }
}
